import config from "../../config";

export function isProductionUrl(): boolean {
  return window.location.hostname === config.productionDomain;
}
